import {TableContainer, Collapse, TableBody, TableCell, TableRow, Paper, Table, Grid, Tabs, Tab} from '@mui/material';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import {useState} from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_TIME, TAB_DATE} from './StatsCommon.js';
import StatsMonthTable from './StatsMonthTable.js';
import StatsFilter from './StatsFilter.js';
import {monthNames} from '../Trans.js';
import {COMM_OK} from '../WsR2.js';

const StatsDateSubRow = (props) => {
	const [dateSpecs, setDateSpecs] = useState(null);
	const [isOpen, setOpen] = useState(false);
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	const user_month = props.month + 1;
	const user_day = props.day + 1;

	function dateSpecsRxWs(status, msg) {
		if (status !== COMM_OK) {
			alert('dateSpecsRxWs: error ' + status);
			return;
		} else if (msg.result !== 'OK') {
			alert('dateSpecsRxWs: ' + msg.data.desc + '!');
			return;
		}

		// console.log('dateSpecsRxWs', msg);
		setDateSpecs(msg.data.species.sort((a, b) => {
			return a.start_t - b.start_t;
		}))
	}

	function loadDateSpecs() {
		const msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'date',
			op: 'date_species',
			data: {
				day: user_day,
				month: user_month,
				year: gStorage.stats.statsYear,
				country: gStorage.stats.country.id,
				user: gStorage.conn.user.id,
			}
		};

// 		console.log('loadDateSpecs', msg);
		gStorage.conn.ws.send(msg, dateSpecsRxWs);
	}

	const tglOpen = () => {
		if (!isOpen) {
			if (gStorage.conn.online && !dateSpecs) {
				loadDateSpecs();
			}
		}

		setOpen(!isOpen);
	}

	const today = new Date();

	const rowColor = user_day === today.getDate() && props.month === today.getMonth() ? '#b9f6ca' : 'default';
	
	return (
		<>
			<TableRow key={props.month} onClick={tglOpen} sx={{cursor: 'pointer'}} style={{backgroundColor: rowColor}}>
				<TableCell>
					<b>{user_day + '.' + user_month + '. '}</b>
				</TableCell>
				<TableCell align='right'>
					{props.num ? props.num + ' ' + t('stats.species') : ''}
				</TableCell>
			</TableRow>

			<TableRow key={12 + props.month} style={{'& > *': { borderTop: 'unset' }}} >
				<TableCell sx={{ paddingBottom: 0, paddingTop: 0 }} colSpan={2}>
					<Collapse in={isOpen} timeout="auto" unmountOnExit>
						<StatsMonthTable 
							src={dateSpecs}
							hideHeader={1}
						/>
					</Collapse>
				</TableCell>
			</TableRow>
		</>
	);
};

const StatsDateMonthTable = (props) => {
	const {t} = useTranslation('obs');
	const month = props.month;

	if (!props.data || !props.data.dates || !props.visible)
		return null;

	const start = month * 31;
	const end = start + 31;

	const m_slice = props.data.dates.slice(start, end);
	let m_cnt = 0, m_sum = 0;

	m_slice.forEach(m => {
		if (m > 0)
			m_cnt++;

		m_sum += m;
	});

	if (m_cnt <= 0)
		return null;
/*
sx={{
[`& .${tableCellClasses.root}`]: {
	borderBottom: 'none'
}
}}
*/

	return (
		<>
			<div>
				{m_sum + ' ' + t('stats.points') + ' ' + m_cnt + ' ' + t('stats.dates')}
				{m_cnt ?  ', ' + t('stats.average') + ' '  + (m_sum / m_cnt).toFixed(2) : ''}
			</div>

			<TableContainer component={Paper} elevation={0}>
				<Table size='small'>
					<TableBody>
					{
						m_slice.map((num, day) => {
							if ((month === 1 && day > 28) || (((month === 3) || (month === 5) || (month === 8) || (month === 10)) && day > 29))
								return null;

							return <StatsDateSubRow key={day} month={month} day={day} num={num}/>
						})
					}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	)
};

const StatsDate = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	let tot_cnt = 0;

	function dateStatsRxWs(status, msg) {
		if (status !== COMM_OK) {
			alert('dateStatsRxWss: error ' + status);
			return;
		} else if (msg.result !== 'OK') {
			alert('dateStatsRxWs: ' + msg.data.desc + '!');
			return;
		}

		if (gStorage.stats.tab !== TAB_TIME || gStorage.stats.time_tab !== TAB_DATE)
			return;

		// console.log('dateStatsRxWs', msg);
		gStorage.stats.setObsList(msg.data.observations);
	}

	function loadDateStats(tax) {
		const msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'date',
			op: 'species_per_date',
			data: {
				user: gStorage.conn.user.id,
				year: gStorage.stats.statsYear,
				country: gStorage.stats.country.id
			}
		};

// 		console.log('loadDateStats', msg);
		gStorage.conn.ws.send(msg, dateStatsRxWs);
	}

	function dateYearChange(event) {
		gStorage.stats.setStatsYear(event.target.value);
		gStorage.stats.setObsList(null);
	}
	
	function monthTabChange(e, value) {
		gStorage.stats.setDateTab(value);
	}

	if (gStorage.stats.tab !== TAB_TIME || gStorage.stats.time_tab !== TAB_DATE)
		return null;

	if (!gStorage.stats.obsList && gStorage.conn.online) {
		loadDateStats();
		return null;
	}

	if (gStorage.stats.obsList) {
		gStorage.stats.obsList.dates.forEach((num) => {
			tot_cnt += num;
		})
	}

	return (
		<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} columns={1}>
			<Grid size={{xs: 12}} align={'center'}>
				<StatsFilter 
					loc = {{country: {
							value: gStorage.stats.country,
							style: {width: 200}
						}
					}}
					time = {{
						year: {
							year: gStorage.stats.statsYear,
							onChange: dateYearChange,
							enabled: gStorage.conn.online,
							allowNone: true
						}
					}}
				/>
			</Grid>

			<Grid size={{xs: 12}} align={'center'} sx={{marginTop: 2}}>
				{t('stats.date_pts') + ' ' + tot_cnt + ', ' + t('stats.average') + ' ' + (tot_cnt / 366).toFixed(2)}
			</Grid>
				
			<Tabs 
			    value={gStorage.stats.date_tab}
			    onChange={monthTabChange} 
			    align={'center'}
			    indicatorColor="primary"
			    textColor="primary"
			    scrollButtons="auto"
			    variant="scrollable"
			>
				{[...Array(12).keys()].map((val) => {
					const start = val * 31;
					const end = start + 31;
					const m_slice = gStorage.stats.obsList.dates.slice(start, end);

					let m_cnt = 0;

					m_slice.forEach((m) => {
						if (m > 0)
							m_cnt++;
					});

					const c = m_cnt > 0 ? 'default' : 'darksalmon';

					return (
						<Tab key={val}
							sx={{color: c}}
							value={val}
							label={t(monthNames[val])}
						/>
					)
				})}
			</Tabs>

			<Grid size={{xs: 12}} align={'center'} sx={{marginTop: 2}}>
				{[...Array(12).keys()].map((val) => {
					return (
						<StatsDateMonthTable 
							key={val}
							month={val}
							data={gStorage.stats.obsList}
							visible={val === gStorage.stats.date_tab}
						/>
					)
				})}
			</Grid>
		</Grid>
	)
});

export default StatsDate;

